import { TCommonParams } from '@cockpitai/integration/panels/types'
import { useSearchParams } from 'react-router-dom'

const commonFilters = ['affiliateId', 'occupationType', 'withoutWallet', 'supervisor', 'id']

export function useFilterPanels(extras?: any): TCommonParams {
  const [searchParams] = useSearchParams()

  const filtersPossible = extras ? [...commonFilters, ...extras] : commonFilters

  const filters: TCommonParams = {}

  for (const filter of filtersPossible) {
    if (searchParams.has(filter)) {
      const value = searchParams.get(filter)
      if (value !== null) {
        ;(filters as any)[filter] = value
      }
    }
  }

  return filters
}
